import React, { useEffect, useState } from 'react';
import { Modal, Input } from 'antd';

// Name prompt for creating or renaming a master config (content type).
function ConfigNameModal({ visible, initialName, isEditing, onSubmit, onCancel }) {
  const [name, setName] = useState('');

  useEffect(() => {
    if (visible) {
      setName(initialName || '');
    }
  }, [visible, initialName]);

  const isValid = name.trim().length > 0;

  const handleSubmit = () => {
    if (!isValid) return;
    onSubmit(name.trim());
  };

  return (
    <Modal
      visible={visible}
      title={isEditing ? 'Rename Content Type' : 'New Content Type'}
      className="adsign-modal"
      closeIcon={<i className="feather-x" />}
      onOk={handleSubmit}
      onCancel={onCancel}
      okText="Submit"
      okButtonProps={{
        className: isValid ? 'button-submit' : 'button-submit disabled',
        disabled: !isValid,
      }}
      cancelButtonProps={{
        className: 'button-cancel',
      }}
    >
      <div className="form">
        <label className="form-label">Name</label>
        <Input
          placeholder="e.g. Promotions"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onPressEnter={handleSubmit}
          className="input-adsign"
        />
      </div>
    </Modal>
  );
}

export default ConfigNameModal;
